import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/workspace/src/layouts/blogPost.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Today, we are excited to share some recent features and improvements to the Starswap ecosystem:`}</p>
    <ul>
      <li parentName="ul">{`Layer 2 Beta (Improved UX!)`}</li>
      <li parentName="ul">{`Developer Guides`}</li>
      <li parentName="ul">{`Help Center`}</li>
      <li parentName="ul">{`EIP-1559 Support`}</li>
      <li parentName="ul">{`ENS on Sybil`}</li>
    </ul>
    <h1 {...{
      "id": "layer-2-beta",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#layer-2-beta",
        "aria-label": "layer 2 beta permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Layer 2 Beta`}</h1>
    <p>{`The Starswap v3 deployments on Optimistic Ethereum and Arbitrum are ready to graduate from Alpha to Beta.`}</p>
    <p>{`We’re excited to release the network selector dropdown in the Starswap App! Starting with today’s Beta release, users can seamlessly access all supported networks directly in the Starswap App.`}</p>
    <p><img parentName="p" {...{
        "src": "/bf66b1f9216388568f8654b3c5e0b671/network_selector.gif",
        "alt": null
      }}></img></p>
    <p>{`We’ve also released a fast confirmation UX to showcase the lightning speed of Layer 2 networks!`}</p>
    <p><img parentName="p" {...{
        "src": "/8ed3f5e191a052ae728a49219fb401d3/fast_confirmation.gif",
        "alt": null
      }}></img></p>
    <p>{`Lastly, as a precautionary measure, we’ve implemented downtime detection so the Starswap App will report liveness of the network.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/5d17063912fbf79f7e7340d686105b27/3ceac/downtime_alert.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACGUlEQVQoz32Ry2oUQRRA5yOCEGe6qru6qx9V3T3dPY9MNJPJRAjGECE+QKOQREFQUFypQQQJCG78BTcu/AV/w50r/8L1ke7MxDEGF4e6UHXPfVQrSCrCbAVlh3h2hMqv4nXHyHxMJxvj5Os43Q1EMUUWG8higmNXUXZAmPYJTEmYDTGmhx9XtISfInQXGZbIuIdMhsiwQE33Ke+9oty8Q7H1ALNxF712i2DtNiofU5QjhOuzdGmZtmcQUdV4WtK3yCBD6hypu7hRiQhywv41dp59YO/lJ248/cjmoxOu7L9lcP8denCdXm+AjtJGKnyDW+f7KS3pJUhlkMpyJvctnhmh6jGzMXrykGznOWpyhJo+xs3Wqao+WV6RmAwvMIjGYWphzB+SBjErok0fRxmEbxvqWIU5fpiSZiVBaNChxVUxYuY4JzxFuBGuMmTdIdbmJLbEpD2StCLNB/ja0hFh827OPLdVm+csCqVKKLZfUO69x4x2MSbDZD2ybr8RLkrmOeJ8h8KdyZvLhKDcIujvEuQTtF3Bt6sE6SqunyKbKWJcLzpDetGpcLFa0+msWtuvGjp6QCdcoa1rhjiexZERy078Fx150Q5nsvqUbriAPovrBgId0S9O6XUjBkVEFEX/Chc7vAhPxSwtxxzcDPjxpc33z21+fnX49c3h+Mi/+Jf/R72ry07M2jDk+FDx+kDx5tDn5Ilie6L5DS4xa6jBIofbAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "downtime alert",
            "title": "downtime alert",
            "src": "/static/5d17063912fbf79f7e7340d686105b27/c1b63/downtime_alert.png",
            "srcSet": ["/static/5d17063912fbf79f7e7340d686105b27/5a46d/downtime_alert.png 300w", "/static/5d17063912fbf79f7e7340d686105b27/0a47e/downtime_alert.png 600w", "/static/5d17063912fbf79f7e7340d686105b27/c1b63/downtime_alert.png 1200w", "/static/5d17063912fbf79f7e7340d686105b27/3ceac/downtime_alert.png 1456w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`The early successes of Optimistic Ethereum and Arbitrum have been incredibly promising. We’re excited to offer a better experience in the Starswap App and hope it will invite more users to experiment with L2 networks.`}</p>
    <p><strong parentName="p">{`Optimistic Ethereum`}</strong>{` - Since launching Starswap v3 on `}<a parentName="p" {...{
        "href": "https://starswap.xyz/blog/Starswap-optimism-alpha/"
      }}>{`Optimistic Ethereum`}</a>{` two months ago, total value locked (`}<a parentName="p" {...{
        "href": "https://info.starswap.xyz/#/optimism/"
      }}>{`TVL`}</a>{`) has steadily grown to $35M. Over the past 30 days alone, 49,000 unique addresses have generated $165m volume across 158k trades, regularly saving up to 25x on swap costs relative to L1!`}</p>
    <p>{`We want to highlight that the Optimistic Ethereum network will undergo a `}<a parentName="p" {...{
        "href": "https://medium.com/ethereum-optimism/the-future-of-optimistic-ethereum-7f22d987331"
      }}>{`‘Regenesis’`}</a>{`. Both Starswap Labs and the Optimism team will provide further reminders and notices as we get closer to the Regenesis event.`}</p>
    <p><strong parentName="p">{`Arbitrum`}</strong>{` - Starswap v3 was deployed on Arbitrum on `}<a parentName="p" {...{
        "href": "https://github.com/Starswap/Starswap-interface/pull/1716"
      }}>{`June 2`}</a>{` following a community `}<a parentName="p" {...{
        "href": "https://snapshot.org/#/Starswap/proposal/Qmehop1NNWP9VEf7tGLEAYRphVsXtdxkL7oKEhaXL2Xao6"
      }}>{`snapshot`}</a>{` vote. The network `}<a parentName="p" {...{
        "href": "https://starswap.xyz/blog/Starswap-arbitrum-alpha/"
      }}>{`officially opened`}</a>{` to the public on August 31 and adoption has quickly soared: over the past two weeks, the Arbitrum deployment has seen over $345M `}<a parentName="p" {...{
        "href": "https://info.starswap.xyz/#/arbitrum/"
      }}>{`trade volume`}</a>{` on $39M `}<a parentName="p" {...{
        "href": "https://info.starswap.xyz/#/optimism/"
      }}>{`TVL`}</a>{`!`}</p>
    <p>{`Although user funds were never at risk, the Arbitrum sequencer `}<a parentName="p" {...{
        "href": "https://medium.com/offchainlabs/arbitrum-one-outage-report-d365b24d49c"
      }}>{`experienced 45 minutes of downtime`}</a>{` on September 14. We want to remind users that further outages are still possible as the Arbitrum network continues to find its feet. Nevertheless, we believe that the limited extent and severity of issues to date warrants cautiously moving the Starswap v3 deployment to Beta status.`}</p>
    <h1 {...{
      "id": "developer-guides",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#developer-guides",
        "aria-label": "developer guides permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Developer Guides`}</h1>
    <p>{`We are committed to educating developers and making the Starswap protocol more accessible to all with informative developer docs and guides.`}</p>
    <p>{`To that end, we have published six new developer guides:`}</p>
    <ul>
      <li parentName="ul">{`Smart Contract Guides`}<ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.starswap.xyz/protocol/guides/swaps/single-swaps"
            }}>{`How to Swap`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.starswap.xyz/protocol/guides/providing-liquidity/setting-up"
            }}>{`How to Provide Liquidity`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.starswap.xyz/protocol/guides/liquidity-mining/liquidity-mining-overview"
            }}>{`How to Create a Liquidity Mining program`}</a></li>
        </ul></li>
      <li parentName="ul">{`Javascript SDK Guides`}<ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.starswap.xyz/sdk/guides/execute-a-swap"
            }}>{`How to Swap`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.starswap.xyz/sdk/guides/liquidity/minting"
            }}>{`How to Provide Liquidity`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.starswap.xyz/sdk/guides/fetching-prices"
            }}>{`How to Fetch Spot Prices`}</a></li>
        </ul></li>
    </ul>
    <p>{`We’ll continue publishing docs on a weekly basis so stay tuned for more!`}</p>
    <h1 {...{
      "id": "help-center",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#help-center",
        "aria-label": "help center permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Help Center`}</h1>
    <p>{`We are steadily expanding the Starswap `}<a parentName="p" {...{
        "href": "https://help.starswap.xyz/en/"
      }}>{`Help Center`}</a>{` to offer more walkthroughs and FAQs.`}</p>
    <p>{`Recently we published a complete set of guides to walk you through every step from deposit to withdrawal on Layer 2 `}<a parentName="p" {...{
        "href": "https://help.starswap.xyz/en/collections/3137778-Starswap-on-optimistic-ethereum-o%CE%BE"
      }}>{`Optimistic Ethereum`}</a>{` and `}<a parentName="p" {...{
        "href": "https://help.starswap.xyz/en/collections/3137787-Starswap-on-arbitrum"
      }}>{`Arbitrum User Guides`}</a>{`. We’ve also added an `}<a parentName="p" {...{
        "href": "https://help.starswap.xyz/en/collections/3033722-faq"
      }}>{`FAQ`}</a>{` and article about `}<a parentName="p" {...{
        "href": "https://help.starswap.xyz/en/articles/5392378-swap-errors-advanced"
      }}>{`Swap Error Codes`}</a>{`.`}</p>
    <h1 {...{
      "id": "eip-1559-support",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#eip-1559-support",
        "aria-label": "eip 1559 support permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`EIP-1559 Support`}</h1>
    <p>{`Ethereum upgraded to EIP-1559 last month and we’re happy to say that it is fully compatible with the Starswap app. The app now sends a type 2 transaction to nudge your wallet to choose the optimal Base Fee and Priority Fee for your transaction.`}</p>
    <p>{`Since the EIP-1559 launch, 43,577 ETH has been burned by transactions interacting with the Starswap Protocol.`}</p>
    <h1 {...{
      "id": "ens-on-sybil",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ens-on-sybil",
        "aria-label": "ens on sybil permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`ENS on Sybil`}</h1>
    <p>{`We’ve added Ethereum Name Service (ENS) support to `}<a parentName="p" {...{
        "href": "https://sybil.org"
      }}>{`sybil.org`}</a>{`! If an address is not Twitter verified, Sybil will now fetch their ENS name to help you identify the delegate.`}</p>
    <hr></hr>
    <p>{`To get involved and stay up to date:`}</p>
    <ul>
      <li parentName="ul">{`Join the Starswap community `}<a parentName="li" {...{
          "href": "https://discord.com/invite/FCfyBSbCU5"
        }}>{`discord`}</a></li>
      <li parentName="ul">{`Follow Starswap Labs on `}<a parentName="li" {...{
          "href": "/Starswap"
        }}>{`Twitter`}</a></li>
      <li parentName="ul">{`Subscribe to the Starswap Labs `}<a parentName="li" {...{
          "href": "https://starswap.xyz/rss.xml"
        }}>{`blog`}</a></li>
      <li parentName="ul">{`Register as a delegate on `}<a parentName="li" {...{
          "href": "https://sybil.org/#/delegates/Starswap"
        }}>{`Sybil`}</a></li>
      <li parentName="ul">{`Participate in Starswap `}<a parentName="li" {...{
          "href": "https://gov.starswap.xyz/"
        }}>{`governance`}</a></li>
    </ul>
    <p>{`Starswap Team
🦄`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      